/* screens/dev/UiKitParts4.jsx — витрина (часть 4, S3): блоки и контролы редактора ТТК.
   IngredientsTable (полный/пустой), IngredientPicker (combobox), KitchenPicker +
   MultiGramsStep (живой 2-шаговый флоу), AllergenChips/AutoHint, KbjuTable + CostSummary,
   PortionsSelector, AnchorNav (полоска). Все состояния — на статичных фикстурах. */

import React from 'react';
import { AllergenAutoHint, AllergenChips } from '../../components/kitchen/AllergenControls.jsx';
import { IngredientPicker, KitchenPicker, MultiGramsStep } from '../../components/kitchen/IngredientPickers.jsx';
import { IngredientsTable } from '../../components/kitchen/IngredientsTable.jsx';
import { TTKAnchorNav } from '../../components/kitchen/TTKAnchorNav.jsx';
import { CostSummaryBlock, KbjuTable, PortionsSelector, RecipeBindingSummary } from '../../components/ttk/TTKViewBlocks.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { UiKitSection as Section, UiKitStateBox as StateBox } from './UiKitParts1.jsx';

  const { useState } = React;

  const ROWS = [
    { _rid: 'a', name_raw: 'Говядина (лопатка)', target_kind: 'card', target_id: 101, target_label: 'Говядина, вырезка охлаждённая', amount_brutto_g: 80, amount_netto_g: 59, weight_in_dish_g: 40, unit: 'г', cold_loss_pct: 26.3, hot_loss_pct: 32.2 },
    { _rid: 'b', name_raw: 'Лук репчатый', target_kind: 'card', target_id: 123, target_label: 'Лук репчатый', amount_brutto_g: 30, amount_netto_g: 25, weight_in_dish_g: 18, unit: 'г', cold_loss_pct: 16.7, hot_loss_pct: 28 },
    // Привар: паста впитала воду, выход 240 > нетто 120 → hot_loss_pct < 0 (показывается «+100 привар»).
    { _rid: 'c', name_raw: 'Спагетти №5', target_kind: null, target_id: null, target_label: null, amount_brutto_g: 120, amount_netto_g: 120, weight_in_dish_g: 240, unit: 'г', cold_loss_pct: 0, hot_loss_pct: -100 },
  ];
  const SECTIONS = [
    { id: 'ttk-r1', num: 1, label: 'Область' }, { id: 'ttk-r2', num: 2, label: 'Сырьё' },
    { id: 'ttk-r3', num: 3, label: 'Рецептура' }, { id: 'ttk-r7', num: 7, label: 'Ценность' },
  ];

  function TTKEditorSection() {
    const [bind, setBind] = useState(null);
    const [allergens, setAllergens] = useState(['Глютен', 'Молоко']);
    const [scale, setScale] = useState('1');
    const [pickerOpen, setPickerOpen] = useState(false);
    const [gramsFor, setGramsFor] = useState(null);
    const noop = () => {};

    return (
      <Section id="ttk" title="Редактор ТТК (S3)"
        sub="View-блоки и контролы редактора ТТК. Derived-поля (% потерь, себест., FC%) — нередактируемы и визуально отличны от полей ввода. На ≤720px таблица состава становится карточками-аккордеоном.">

        <StateBox label="IngredientsTable · состав (на ≤720px → карточки)">
          <IngredientsTable rows={ROWS} scale={scale} onRowChange={noop} onDelete={noop} onRebind={noop} onOpenTarget={noop} />
          <div className="cluster cluster-12" style={{ marginTop: 'var(--space-10)', justifyContent: 'space-between' }}>
            <RecipeBindingSummary bound={2} total={3} />
            <PortionsSelector value={scale} onChange={setScale} />
          </div>
        </StateBox>

        <StateBox label="IngredientPicker · combobox привязки строки (поиск, ↑↓/Enter/Esc)">
          <div style={{ maxWidth: 320 }}>
            <IngredientPicker value={bind} kind="card" onChange={setBind} placeholder="Не привязан" />
          </div>
        </StateBox>

        <StateBox label="KitchenPicker → MultiGramsStep · добавление состава (2 шага)">
          <div className="cluster cluster-8">
            <Button variant="secondary" size="sm" iconLeft="plus" onClick={() => setPickerOpen(true)}>Добавить ингредиенты</Button>
            <span className="t-body-sm text-mute">Выбор сырья → обязательное брутто (фикс боли №52).</span>
          </div>
          {pickerOpen && (
            <KitchenPicker open kind="card" multi onClose={() => setPickerOpen(false)}
              onConfirm={(ents) => { setGramsFor(ents); setPickerOpen(false); }} />
          )}
          {gramsFor && (
            <MultiGramsStep open entities={gramsFor}
              onBack={() => { setPickerOpen(true); setGramsFor(null); }}
              onClose={() => setGramsFor(null)}
              onConfirm={() => setGramsFor(null)} />
          )}
        </StateBox>

        <StateBox label="AllergenChips (ручные) + AllergenAutoHint (derived из состава)">
          <AllergenChips value={allergens} onChange={setAllergens} />
          <div style={{ marginTop: 'var(--space-8)' }}>
            <AllergenAutoHint items={['Глютен', 'Молоко', 'Яйца']} manual={allergens} />
          </div>
        </StateBox>

        <StateBox label="KbjuTable + CostSummaryBlock (derived, нередактируемо)">
          <div className="cluster cluster-16" style={{ alignItems: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 280px' }}>
              <KbjuTable per_portion={{ kcal: 320, protein: 14, fat: 12, carbs: 28 }} per_100g={{ kcal: 91, protein: 4, fat: 3.4, carbs: 8 }} />
            </div>
            <div style={{ flex: '1 1 260px' }}>
              <CostSummaryBlock cost_per_portion_rub={142} cost_per_100g_rub={41} output_g={350} selling_price_rub={420} cost_status="ok" fc_pct={33.8} />
            </div>
          </div>
        </StateBox>

        <StateBox label="AnchorNav · навигация по разделам (полоска на md/lg; колонка на 4k)">
          <TTKAnchorNav items={SECTIONS} variant="bar" />
        </StateBox>

        <StateBox label="IngredientsTable · пустой состав">
          <p className="t-body-sm text-mute">При пустом составе редактор показывает EmptyState с кнопкой «Добавить ингредиенты» (см. /kitchen?tab=recipes&edit=ttk-307).</p>
        </StateBox>
      </Section>
    );
  }

export { TTKEditorSection };
